module.exports = __webpack_public_path__ + "static/media/japan.0c764c1a.jpg";